// Eckdaten des Leads in einem kleinen Fenster am Kopf (Runde 7B, L06): Ort, Lead seit, letzte Aktivität, wann der Lead zuletzt aus
// Close geladen wurde, von wem angelegt. Close hat das nicht; im CRM nützlich, solange beide Systeme laufen (der Abgleichstand zeigt,
// wie frisch die Daten sind). Bewusst kein Streifen unter dem Namen (Dilsar, 16.10.): der Kopf bleibt eine Zeile.
import { useState } from "react";
import type { Lead } from "../../api";
import { useMeta } from "../../daten/meta";
import { relativ, zeitpunktLang, zeitpunktText } from "../../werkzeuge/zeit";
import { Ausklapp } from "../Ausklapp";
import { Icon } from "../Icon";
import { TL } from "./leadTexte";
import "./leadTiefe.css";

export function Eckdaten({ lead, letzteAktivitaet }: { lead: Lead; letzteAktivitaet?: string | null }) {
  const meta = useMeta();
  const [offen, setOffen] = useState(false);
  const [anker, setAnker] = useState<HTMLButtonElement | null>(null);
  const adresse = (lead.addresses ?? []).find((a) => a.city || a.zipcode) ?? null;
  const ort = adresse ? [[adresse.zipcode, adresse.city].filter(Boolean).join(" "), adresse.country && adresse.country !== "DE" ? adresse.country : null].filter(Boolean).join(", ") : "";
  const zeile = (label: string, wert: string | null, titel?: string) => (
    <div className="ek__zeile">
      <dt>{label}</dt>
      <dd title={titel}>{wert || TL.kopf.keine}</dd>
    </div>
  );
  return (
    <>
      <button
        ref={setAnker}
        type="button"
        className="symbolknopf symbolknopf--klein ls-kopf__mehr"
        title={TL.kopf.eckdaten}
        aria-label={TL.kopf.eckdaten}
        aria-haspopup="dialog"
        aria-expanded={offen}
        onClick={() => setOffen((o) => !o)}
      >
        <Icon name="info" groesse={14} />
      </button>
      <Ausklapp anker={anker} offen={offen} onSchliessen={() => setOffen(false)} breite={280} rolle="dialog">
        <dl className="ek">
          {zeile(TL.kopf.ort, ort)}
          {zeile(TL.kopf.leadSeit, lead.date_created ? zeitpunktText(lead.date_created) : null, zeitpunktLang(lead.date_created))}
          {zeile(TL.kopf.letzteAktivitaet, letzteAktivitaet ? `${zeitpunktText(letzteAktivitaet)} (${relativ(letzteAktivitaet)})` : null, zeitpunktLang(letzteAktivitaet))}
          {zeile(TL.kopf.abgleich, lead.crm?.synced_at ? relativ(lead.crm.synced_at) : null, zeitpunktLang(lead.crm?.synced_at))}
          {zeile(TL.kopf.angelegtVon, lead.created_by ? meta.nutzerName(lead.created_by) : null)}
        </dl>
      </Ausklapp>
    </>
  );
}
